export const BuildInfo = {timestamp:1788560437000}
